document.querySelectorAll(".element-services").forEach((el) => {
  const imageHolder = el.querySelector(".service-images");

  el.querySelectorAll(".service-item").forEach((item) => {
    item.addEventListener("mouseenter", () => {
      imageHolder.querySelector(`.service-image[data-id="${item.dataset.id}"]`).classList.add("is-active");
    });

    item.addEventListener("mouseleave", () => {
      imageHolder.querySelectorAll(".service-image").forEach((image) => image.classList.remove("is-active"));
    });
  });
});
